import { WebPlugin } from '@capacitor/core';
export class LocalizationSettingsWeb extends WebPlugin {
    async getLanguage() {
        return { value: navigator.language };
    }
    async setLanguage(options) {
        return options;
    }
}
//# sourceMappingURL=web.js.map